import blikAgreementIcon from 'assets/images/finalScreen/ico-blik-pin.png';
import { fadeInAnimationLong, fadeInAnimationShort, styles } from 'consts';
import styled from 'styled-components';

const { animationLong, animationShort, white, fontMBank, fontMontserrat, bluePrimary, primaryBlack } = styles;

const Container = styled.div`
  background: ${white};
  border-radius: 0.5rem;
  height: 28.5rem;
  box-sizing: border-box;
  padding: 2.5rem 0 2rem;

  @media (min-width: 768px) {
    padding-top: 3.1875rem;
  }
`;

const Animation = styled.div`
  ${fadeInAnimationShort};
  animation: ${animationShort};
`;

const Title = styled(Animation)`
  h3 {
    padding: 0 0.5rem;
    max-width: 24rem;
    margin: 0 auto;
    height: 5rem;
    font-family: ${fontMBank};
    font-size: 1.75rem;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.25;
    letter-spacing: normal;
    text-align: center;
    color: ${bluePrimary};

    @media (min-width: 768px) {
      width: 24rem;
      font-size: 2rem;
    }
  }
`;

const Image = styled.img.attrs({
  alt: 'Paynow',
  src: blikAgreementIcon,
})`
  ${fadeInAnimationLong};
  animation: ${animationLong};
  height: 9.375rem;
  width: 12.375rem;
  object-fit: contain;
  display: block;
  margin: 0.5rem auto 0.875rem;

  @media (min-width: 768px) {
    margin-bottom: 1.1875rem;
  }
`;

const Caption = styled(Animation)`
  padding: 0 0.5rem;
  max-width: 24rem;
  height: 3rem;
  font-family: ${fontMontserrat};
  margin: 0 auto 1.5rem;
  font-size: 1.375rem;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: ${primaryBlack};

  @media (min-width: 768px) {
    width: 24rem;
  }
`;

export { Caption, Container, Image, Title };
